import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'onSearchBoxResize',
    (scenarioId: SearchScenarioId, searchBoxWidth: number) => {
        const store = getScenarioStore(scenarioId);
        store.searchBoxWidth = searchBoxWidth;
    }
);
